export enum BankingSalesOrderNote {
  SalesEntry = 'Stand Alone Sales Order - Sales Entry',
  ProductEntry = 'Stand Alone Sales Order - Product Entry'
}